import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/api";
import { Inquiry } from "@/types";

export default function AdminInquiries() {
  const [inquiries, setInquiries] = useState<Inquiry[]>([]);

  const load = () => api.get("/admin/inquiries").then((r) => setInquiries(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const del = async (id: string) => {
    if (!window.confirm("Delete this inquiry?")) return;
    try {
      await api.delete(`/admin/inquiries/${id}`);
      toast.success("Inquiry deleted");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="admin-inquiries">
      <h2 className="mb-4 text-sm font-bold text-stone-900">Inquiries ({inquiries.length})</h2>
      <div className="flex flex-col gap-3">
        {inquiries.map((q) => (
          <div key={q.id} data-testid={`inquiry-row-${q.id}`} className="border border-stone-200 p-4">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div>
                <p className="text-sm font-semibold text-stone-900">{q.name}</p>
                <a href={`mailto:${q.email}`} className="text-xs text-blue-700 hover:underline">{q.email}</a>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-[11px] text-stone-400">{new Date(q.created_at).toLocaleString()}</span>
                <button data-testid={`inquiry-delete-${q.id}`} onClick={() => del(q.id)} className="border border-red-200 px-2 py-1 text-xs text-red-600 hover:bg-red-50">
                  <Trash2 size={13} />
                </button>
              </div>
            </div>
            <p className="mt-2 whitespace-pre-wrap text-sm text-stone-700">{q.project_need}</p>
            {(q.plans || []).length > 0 && (
              <div className="mt-2 flex flex-wrap gap-1">
                {q.plans.map((p) => (
                  <span key={p} className="border border-stone-300 bg-stone-50 px-1.5 py-0.5 text-[10px] font-semibold text-stone-600">{p}</span>
                ))}
              </div>
            )}
            {q.other_details && <p className="mt-1.5 text-xs text-stone-500">Other: {q.other_details}</p>}
            {q.socials && <p className="mt-1.5 text-xs text-stone-500">Socials: {q.socials}</p>}
          </div>
        ))}
        {inquiries.length === 0 && <p className="text-xs text-stone-500">Inbox zero. No inquiries yet.</p>}
      </div>
    </div>
  );
}
